<template>
    <v-select
      :items="allValueOptions"
      :value="value"
      @change="update"
      :label="name"
      :hint="name"
      :error-messages="errorMessages"
    />
</template>

<script>

export default {
  name: 'OptionMetadata',
  props: {
    name: {
      type: String,
      mandatory: true,
    },
    value: {
    },
    valueOptions: {
      type: Array,
      mandatory: true,
    },
    mandatory: {
      type: Boolean,
      mandatory: true,
    },
  },
  components: {
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    errorMessages() {
      if (!this.mandatory) {
        return null;
      }

      return !this.value ? 'Pflichfeld' : null;
    },
    allValueOptions() {
      const result = [{
        text: ' - ',
        value: null,
      }];

      this.valueOptions.forEach(v => {
        result.push({
          text: v,
          value: v,
        })
      });

      return result;
    }
  },
  methods: {
    update(newValue) {
      this.$emit('input', newValue);
    },
  },
  data() {
    return {
    };
  },
};
</script>
